import { Award } from "lucide-react";
import { shortDate } from "./kit";

/** Full-width banner on a player's profile for the week they're the 7 C's Player of the Week. */
export const WinnerBanner = ({ award, count }) => (award ? (
  <div data-testid="potw-banner" className="relative mb-6 overflow-hidden rounded-2xl bg-[#39FF14] px-5 py-4 text-[#0A0E1A]">
    <div aria-hidden className="pointer-events-none absolute -right-4 -top-8 font-display text-[120px] font-black leading-none text-[#0A0E1A]/10">7C</div>
    <div className="relative flex flex-wrap items-center gap-x-4 gap-y-1">
      <Award className="h-8 w-8 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-mono-gd text-[11px] font-bold uppercase tracking-[0.25em]">7 C's Player of the Week · Week of {shortDate(award.week)}</p>
        <p data-testid="potw-banner-c" className="font-display text-2xl font-black uppercase leading-tight sm:text-3xl">{award.c_name}</p>
      </div>
      {count > 1 && <p data-testid="potw-banner-count" className="font-mono-gd text-xs font-bold uppercase tracking-wider">{count}× winner</p>}
    </div>
  </div>
) : null);
